import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  setCurrentPage,
  setIsEditMode,
  setIsErrorMsgShown,
  setIsModalsBgShown,
  setIsSuccessMsgShown,
} from "../../redux/globalFnSlice";

// Custom Hook to handle status effects.
export function useStatusEffect({
  status,
  successMessage,
  errorMessage,
  onSuccess,
  onError,
  resetStatus,
  reFetch,
  onPage,
  functionName,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (status === "success") {
      dispatch(reFetch({ page: onPage }));
      dispatch(setCurrentPage(onPage));
      if (
        functionName === "createOrg" ||
        functionName === "deleteOrg" ||
        functionName === "updateOrg"
      ) {
        dispatch(setIsModalsBgShown(false));
      }
      dispatch(onSuccess());
      dispatch(setIsSuccessMsgShown(successMessage));
      dispatch(setIsEditMode());
      setTimeout(() => {
        dispatch(resetStatus());
        dispatch(setIsSuccessMsgShown(""));
      }, 2000);
    } else if (status === "error") {
      if (functionName === "createOrg") {
        dispatch(setIsModalsBgShown(false));
      }
      dispatch(onError());
      dispatch(setIsErrorMsgShown(errorMessage));
      dispatch(setIsEditMode());
      setTimeout(() => {
        dispatch(resetStatus());
        dispatch(setIsErrorMsgShown(""));
      }, 2000);
    }
  }, [status]);
}
